export { init } from './init';
export { config } from './config';



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/export.ts
 **/